var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.306 6.15345C11.306 7.16613 11.0057 8.15607 10.4431 8.99807C9.88046 9.84007 9.08077 10.4963 8.14515 10.8838C7.20953 11.2713 6.18002 11.3726 5.18681 11.175C4.1936 10.9774 3.28131 10.4896 2.5653 9.77348C1.8493 9.05734 1.36174 8.14494 1.1643 7.1517C0.966856 6.15845 1.06839 5.12896 1.45607 4.19342C1.84374 3.25787 2.50014 2.45831 3.34225 1.89584C4.18436 1.33336 5.17436 1.03325 6.18704 1.03345C7.54478 1.03371 8.84681 1.57326 9.80678 2.53341C10.7668 3.49357 11.306 4.79571 11.306 6.15345V6.15345Z",
    stroke: "#111111",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.586 12.5524L9.802 9.76843",
    stroke: "#111111",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_4068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.933,
    height: 13.933,
    fill: "white",
    transform: "translate(0.0670166 0.0334473)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.60c6841187d24dce03781e87bedea486.svg";
export { ForwardRef as ReactComponent };